import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Creators as TaskCreators } from 'store/ducks/task';
import { Creators as ProCreators } from 'store/ducks/pro';
import groupPro from 'assets/img/avatar_profissionais-empresas.svg';

import Rating from 'components/Rating';

import moment from 'moment';

import {
  OrdersColumn,
  ProOrderCard,
  Left,
  ProPhoto,
  RatingCard,
  Right,
  ProName,
  ResumeChat,
  OrderDate,
  OrderPrice,
  RatingStars,
  InvalidatedText,
  UnreadMessages,
} from './styles.js';

const ProOrder = ({
  quote, getProData, active, taskDetail, chat,
}) => {
  const formatAmount = (amount) => {
    if (amount && amount > 0) {
      return amount.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' });
    }
    return '--';
  };

  const unreadMessages = chat.messages ? chat.messages.filter(m => !m.is_read && m.user_id !== chat.user_id).length : null;

  return (
    <ProOrderCard
      onClick={() => (taskDetail.status === 'open' ? getProData(quote) : null)}
      className={active ? 'active' : ''}
      active={active}
      taskHasSelectedQuote={taskDetail.selected_quote.length}
    >
      <Left proValidated={quote.is_validated}>
        <ProPhoto src={quote.company_image_enabled ? groupPro : quote.profile_picture} />
        <RatingCard>
          <RatingStars>
            <Rating initialRating={quote.rating} starSize={10} readonly />
          </RatingStars>
        </RatingCard>
      </Left>
      <Right proValidated={quote.is_validated}>
        {!!unreadMessages && <UnreadMessages>{unreadMessages}</UnreadMessages>}
        <ProName>{quote.company_image_enabled ? quote.company_display_name || quote.user_name : quote.user_name}</ProName>
        <ResumeChat isTyping={chat.userTyping}>
          {(chat.userTyping && 'Digitando...') || (quote.last_message || 'Nenhuma mensagem')}
        </ResumeChat>
        <OrderDate>{quote.last_message_date ? moment(quote.last_message_date).format('DD/MM') : ''}</OrderDate>
        {quote.is_validated ? (
          <OrderPrice>
            {formatAmount(quote.price || 0)}
          </OrderPrice>
        ) : (
          <InvalidatedText>Profissional indisponível</InvalidatedText>
        )}
      </Right>
    </ProOrderCard>
  );
};

const OrdersColumns = ({
  taskDetail,
  taskQuoteProDetail,
  _setTaskQuoteProDetail,
  _getProProfile,
  _getProPortfolio,
  chats,
}) => {
  const getProData = async (quote) => {
    if (quote) {
      await _setTaskQuoteProDetail(quote);
      await _getProProfile(quote.user_id);
      await _getProPortfolio(quote.user_id);
    }
  };

  const getSelectedQuote = () => taskDetail.quotes.find(quote => quote.id === taskDetail.selected_quote[0].id);

  useEffect(() => {
    if (taskDetail && taskDetail.quotes) {
      getProData(taskDetail.selected_quote.length ? getSelectedQuote() : taskDetail.quotes[0]);
    }
  }, [taskDetail.id]);

  return (
    <OrdersColumn overflow={taskDetail && taskDetail.quotes && taskDetail.quotes.length > 4 ? 'true' : 'false'}>
      {taskDetail
        && taskDetail.quotes
        && taskDetail.quotes.map(quote => (
          <ProOrder
            key={quote.id}
            quote={quote}
            taskDetail={taskDetail}
            getProData={getProData}
            active={quote.user_id === taskQuoteProDetail.user_id}
            chat={chats.find(c => c.chat_id === quote.chat_id) || {}}
          />
        ))}
    </OrdersColumn>
  );
};

const mapStateToProps = state => ({
  taskDetail: state.task.taskDetail,
  taskQuoteProDetail: state.task.taskQuoteProDetail,
  proProfile: state.task.taskQuoteProDetail,
  chats: state.chat.chats,
});

const mapDispatchToProps = {
  _setTaskQuoteProDetail: TaskCreators.setTaskQuoteProDetail,
  _getProProfile: ProCreators.getProProfileRequest,
  _getProPortfolio: ProCreators.getProPortfolioRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrdersColumns);
